<template>
  <span>
    <v-icon class="mr-2" @click.stop="dialogClicked()">edit</v-icon>

    <!-- RENAME COHORT FORM DIALOG -->
    <v-dialog v-model="dialog" width="500">
      <v-card class="rounded-lg">
        <v-card-title color="white" primary-title>
          <v-icon color="primary">edit</v-icon>
          <span class="primary--text text--darken-3 title pl-2"
            >Rename Study Group</span
          >
        </v-card-title>

        <v-card-text class="primary primary--text text--lighten-5 pt-4">
          <v-form
            ref="form"
            v-model="valid"
            class="white"
            @submit.prevent="onRenameCohort"
          >
            <v-text-field
              ref="vtf"
              v-model="cohortName"
              :rules="[
                () => !!cohortName || 'Study group name is required.',
                () =>
                  !cohortNames.includes(cohortName) ||
                  cohortName == oldCohortName ||
                  'A study group with that name already exists.',
                () =>
                  !cohortName.startsWith('[O]_') ||
                  'Study group name cannot start with `[O]_`.',
              ]"
              prepend-inner-icon="table_chart"
              label="Please name your study group."
              filled
              text
              background-color="grey lighten-4"
              class="mt-2"
            >
            </v-text-field>
          </v-form>
        </v-card-text>

        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="dialog = false">
            <v-icon left>close</v-icon> Cancel
          </v-btn>
          <v-btn
            :loading="loading"
            color="primary"
            :disabled="cohortName == oldCohortName"
            @click="onRenameCohort"
          >
            <v-icon left>edit</v-icon> Rename Study Group</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </span>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { actions, state } from '@/store/modules/cohortManager/types';

// which store?
export default {
  props: {
    cohort: {
      type: Object,
      required: true,
    },
    cohorts: {
      type: Array,
      default: () => [],
    },
    selected: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    cohortName: '',
    oldCohortName: '',
    valid: true,
    dialog: false,
    loading: false,
  }),
  computed: {
    ...mapState('cohortManager', {
      selectedAnalysisMode: state.SELECTED_ANALYSIS_MODE,
    }),
    cohortNames() {
      return this.cohorts.map(c => c.label.replace(/^\[O\]_/, ''));
    },
  },
  watch: {
    dialog(val) {
      if (val) {
        this.showing();
      }
    },
  },
  methods: {
    ...mapActions('cohortManager', {
      renameCohort: actions.RENAME_COHORT,
    }),
    showing() {
      setTimeout(() => {
        this.$refs.vtf.focus();
      });
    },
    dialogClicked() {
      this.dialog = !this.dialog;
      if (this.dialog) {
        this.cohortName = this.cohort.label.replace(/^\[O\]_/, '');
        this.oldCohortName = this.cohortName;
      }
    },
    async onRenameCohort() {
      let cohortName = this.cohortName;

      if (this.selectedAnalysisMode == 'Outcome based') {
        cohortName = '[O]_' + cohortName;
      }

      if (this.$refs.form.validate()) {
        this.loading = true;
        try {
          let args = {
            cohortId: this.cohort.id,
            cohortName: cohortName,
          };
          await this.renameCohort(args);
          this.loading = false;
          this.dialog = false;
          this.$emit('cohortRenamed');
        } catch (err) {
          this.loading = false;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped></style>
